import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from 'shared/config/env.config';
import { BaseHttpService } from 'shared/base/_base-http.service';
import { contentHeaders } from 'common/headers';
import * as _ from 'lodash';

@Injectable()
export class ResetPasswordService {

    private rootUrl: string = 'reset-password';

    constructor(
      private http: HttpClient
    ) {}

    reset(token: string, password: string, passwordConfirm: string): Observable<any> {
      const body = {token: token, password: password, password_confirmation: passwordConfirm};

      return this.http.post(Config.API + '/' + this.rootUrl, body, {headers: contentHeaders})
            ;
    }
}
